import React, { useState } from 'react';
import {
  // Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  DialogTitle,
  Button,
} from "@mui/material";
import { connect } from 'react-redux';
import axios from 'axios';
import { updateAlert } from '../../../redux/actions';

function RemoveModel({ open, setOpen, selectedModel, reload, setReload, user, handleAlert }) {

  const [deleteName, setDeleteName] = useState("");

  const handleDeleteClose = () => {
    setOpen(false)
  }

  const handleDelete = () => {
    if (deleteName !== selectedModel.name) {
      handleAlert("error", "Names don't match!", 3000)
    } else {
      axios({
        method: "post",
        url: "/api/m2d/models/removeModel",
        data: {
          mid: selectedModel.id,
          uid: user.id
        }
      }).then(() => {
        handleAlert("success", "Successfully Removed!")
        setOpen(false)
        setReload(!reload)
      }).catch((err) => {
        handleAlert("error", err.message, 3000)
        console.error(err)
      })
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleDeleteClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Are you sure you want to remove ${selectedModel.name}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Removing this model will only remove you out of the model owners. This model
            will be removed when all owners have removed this model. This can <b>NOT</b> be undo.
          </DialogContentText>
          <DialogContentText>
            If you really want to remove yourself from this model, please enter the exact same
            model name below and click confirm.
          </DialogContentText>
          <TextField
            required
            label="Model Name"
            fullWidth
            margin="normal"
            placeholder={selectedModel.name}
            value={deleteName}
            onInput={(e) => setDeleteName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={handleDeleteClose}>Cancel</Button>
          <Button variant="contained" onClick={handleDelete}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveModel);
